import { Invoice, InvoiceStatus, InvoiceViewModel } from '@anduin/api';

type InvoiceStatusInput = Pick<InvoiceViewModel, 'isPaid' | 'isOverdue' | 'isDue'> & Partial<Pick<Invoice, never>>;

export function resolveInvoiceStatus(invoice: InvoiceStatusInput): InvoiceStatus {
  if (invoice.isPaid) {
    return InvoiceStatus.PAID;
  }
  if (invoice.isOverdue) {
    return InvoiceStatus.OVERDUE;
  }
  if (invoice.isDue) {
    return InvoiceStatus.DUE;
  }
  return InvoiceStatus.UNPAID;
}
